import { ProcessRunFormCellSize } from "@/features/project-process-run-form-cell-size";
import { ProjectProcessRunFormDatasetSelector } from "@/features/project-process-run-form-dataset-selector";
import { ProcessRunFormDrawGeometry } from "@/features/project-process-run-form-draw-geometry";
import { ProcessRunFormFileFeatureSelector } from "@/features/project-process-run-form-file-feature-selector";
import { ProcessRunFormFile } from "@/features/project-process-run-form-file-selector";
import { ProcessRunFormTabs } from "@/features/project-process-run-form-tabs";
import { ProcessRunFormVectorLayerSelector } from "@/features/project-process-run-form-vector-layer-selector";

import { NumberField } from "../components/process-run-form-fields";

export const FIELDS = {
  draw_geometry: ProcessRunFormDrawGeometry,
  directory_picker: ProcessRunFormFile,
  file_picker: ProcessRunFormFile,
  file_feature_selector: ProcessRunFormFileFeatureSelector,
  tabs: ProcessRunFormTabs,
  cell_size: ProcessRunFormCellSize,
  dataset: ProjectProcessRunFormDatasetSelector,
  vector_layer_selector: ProcessRunFormVectorLayerSelector,
  NumberField,
} as const;
